export const makeFields = (state, setter, fieldsData, onBlur) =>
	Object.keys(fieldsData).reduce(
		(acc, key) => ({ ...acc, [key]: { ...fieldsData[key], state, setter, onBlur } }),
		{}
	);
